import { ToolOutlined } from "@ant-design/icons";
import { ADHOC_PATH } from "constants/index";
import { lazy } from "react";
import { userUtils } from "utils";
import { t } from "utils/i18n";

import { actionConstants, appConstants, resourceConstants } from "constants/permission";
const ConfigSetcode = lazy(() => import("pages/Adhoc/SetCodeConfig/SetCodeConfig"));
const { permission } = userUtils;
const { STAFF_BFF } = appConstants;
const { SKU_RELATIONS, ADHOC_TOOLS } = resourceConstants;
const { READ, UPDATE, READ_VOUCHER_OFFLINE } = actionConstants;
const ConfigSetcodeUpdate = lazy(() => import("pages/Adhoc/SetCodeConfigUpdate/SetCodeConfigUpdate"));
const VoucherOfflineList = lazy(() => import("pages/VoucherOfflineList"));

export default [
  // Parent menu
  {
    path: ADHOC_PATH.ROOT,
    name: t("Adhoc.Root"),
    icon: ToolOutlined,
    children: [ADHOC_PATH.CONFIG_SETCODE, ADHOC_PATH.VOUCHER_OFFLINE],
  },
  // Sub menus
  {
    exact: true,
    path: ADHOC_PATH.CONFIG_SETCODE,
    name: t("Adhoc.ConfigSetcodeManagement"),
    component: ConfigSetcode,
    permissions: [permission(STAFF_BFF, SKU_RELATIONS, READ)],
    Children: [ADHOC_PATH.CONFIG_SETCODE_UPDATE],
  },
  {
    exact: true,
    path: ADHOC_PATH.CONFIG_SETCODE_UPDATE,
    name: t("Adhoc.ConfigSetcodeUpdate"),
    component: ConfigSetcodeUpdate,
    permissions: [permission(STAFF_BFF, SKU_RELATIONS, UPDATE)],
  },
  {
    exact: true,
    path: ADHOC_PATH.VOUCHER_OFFLINE,
    name: t("Adhoc.VoucherOfflineList"),
    component: VoucherOfflineList,
    permissions: [permission(STAFF_BFF, ADHOC_TOOLS, READ_VOUCHER_OFFLINE)],
  },
];
